import { Share2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FadeIn } from "./primitives";
import { toast } from "@/components/ui/sonner";
import { DASHBOARD } from "@/constants/testIds";

export const TellAFriend = () => {
  const share = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied", {
        description: "Share it with someone who might need it.",
      });
    } catch {
      toast("Share 12steps", { description: window.location.href });
    }
  };

  return (
    <FadeIn>
      <Card className="flex flex-col items-start justify-between gap-4 p-6 shadow-soft sm:flex-row sm:items-center">
        <div>
          <h3 className="font-display text-lg font-medium text-foreground">Tell a friend</h3>
          <p className="mt-1 text-[14px] text-muted-foreground">
            Know someone who might find this helpful? Share 12steps with them.
          </p>
        </div>
        <Button
          variant="outline"
          onClick={share}
          data-testid={DASHBOARD.shareButton}
          className="shrink-0"
        >
          <Share2 className="h-4 w-4" /> Share 12steps
        </Button>
      </Card>
    </FadeIn>
  );
};
